import { Flex, Text } from '@sendoutcards/quantum-design-ui'
import { motion } from 'motion/react'
import React, { FC } from 'react'
import { FeatureItem, FeatureItemProps } from './FeatureItem'
import { useSelector } from 'src/hooks'

type FeatureColumn = {
  title?: string
  features: FeatureItemProps[]
}

type FeatureChartProps = {
  columns: FeatureColumn[]
}

export const FeatureItemChart: FC<FeatureChartProps> = ({ columns }) => {
  const windowWidth = useSelector(state => state.window.width)
  const isTablet = windowWidth <= 1000
  const isMobile = windowWidth <= 520
  const animationDuration = isMobile ? 0.25 : 0.4

  return (
    <motion.div
      initial={{ opacity: 0, y: 16, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: animationDuration, ease: 'easeOut' }}
      style={{ width: '100%' }}
    >
      <Flex
        flexDirection={isTablet ? 'column' : 'row'}
        flexWrap={isTablet ? 'wrap' : 'nowrap'}
        justifyContent={isTablet ? 'center' : 'space-between'}
        alignItems="stretch"
        inset={{ horizontal: 'x2_5', vertical: 'x3' }}
        backgroundColor="rgba(64, 64, 64, 0.06)"
        borderRadius="large"
        columnGap="x2"
        maxWidth="1300px"
        style={{
          position: 'relative',
          boxShadow: '0 6px 24px rgba(0,0,0,0.06)',
        }}
      >
        {columns.map((col, colIndex) => {
          const hasFeatures = (col.features?.length ?? 0) > 0
          if (!hasFeatures) return null
          const inferredTitle =
            colIndex === 0 && (!col.title || col.title.trim() === '')
              ? 'Package Includes'
              : col.title
          return (
            <Flex
              key={colIndex}
              width={isTablet ? '100%' : columns.length > 1 ? '50%' : '100%'}
              flexDirection="column"
            >
              {inferredTitle && (
                <Text
                  inset={{ left: '12px' }}
                  type="title"
                  style={{ fontSize: '14px', marginBottom: '8px' }}
                >
                  {inferredTitle}
                </Text>
              )}
              {col.features.map((feature, i) => (
                <FeatureItem key={i} {...feature} />
              ))}
            </Flex>
          )
        })}
      </Flex>
    </motion.div>
  )
}
